import { useEffect, useState } from 'react'
import SeparaterLine from '../../common/SeparaterLine'
import RadioButton from '../../common/RadioButton'
import { Form } from 'react-bootstrap'
import MultiselectDropdown from '../../common/MultiselectDropdown'
import AddTraspButton from '../../firstTimeUserExperience/commonCom/AddTraspButton'
import AddButtonWithArrow from '../../firstTimeUserExperience/commonCom/AddButtonWithArrow'
import RangeDatePicker from '../../common/formControls/RangeDatePicker'
import { useNavigate } from 'react-router'
import { PropertyService, FilterEntityEnum, ReportTypesEnum, UnitService, AnalyticsService } from '@propertelligent/client-api'
import { UserLoginData } from '../../common/charts/Enums'
import apiHelper from '../../../utils/apiHelper'
import { StaticRange } from 'react-date-range';
import { subDays, subMonths, startOfMonth, endOfMonth } from 'date-fns';
import DateHelper from '../../../utils/DateHelper'
import { useGeneratePdfContext } from '../../../utils/context/GeneratePdfContext'
import { TextCss } from '../../GlobalCss/TextCss'

const FiltersForm = ({
    selectedOption,
    setSelectedOption,
    selectedValues,
    setSelectedValues,
    range,
    onHide,
    setRange,
    selectedIds,
    setSelectedIds,
    relativeDateString,
    setRelativeDateString,
    // setReportId = undefined,
    // setReportName = undefined,
    id = null,
    onViewReport = (formValues) => { }

}) => {
    const [multiSelectOptions, setMultiSelectOptions] = useState([])
    const [formValidated, setFormValidated] = useState({
        isSelectedProperties: false,
        isSelectDuration: false
    })
    const navigate = useNavigate()
    const organizationId = parseInt(sessionStorage.getItem(UserLoginData.organization_id));
    const reportType = parseInt(localStorage.getItem("ReportType"))
    const dateFilterTypeId = DateHelper.getDateFilterType(relativeDateString)

    const { setStatementData } = useGeneratePdfContext();



    useEffect(() => {
        if (id === null) {
            setSelectedOption(FilterEntityEnum.Organization)
            setSelectedValues([])
            setSelectedIds([])
            setRange([
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                }
            ])
            setRelativeDateString("")
            // setReportName?.("")
            // setReportId(null)
        }
    }, [id])

    const getFilterData = () => {

        let clientDate = DateHelper.getClientDate()
        apiHelper(AnalyticsService.getApiReport, { showNotification: false }, id, clientDate)
            .then((response: any) => {
                setSelectedOption(response?.data?.success?.queryData?.filterEntityTypeId)
                setSelectedIds(response?.data?.success?.queryData?.filterEntityIds || [])
                setSelectedValues(response?.data?.success?.queryData?.entityNames || [])
                setRange([{
                    startDate: new Date(response?.data?.success?.queryData?.dateFilter?.startDate),
                    endDate: new Date(response?.data?.success?.queryData?.dateFilter?.endDate),
                    key: 'selection',
                }])
                setRelativeDateString(response?.data?.success?.queryData?.dateFilter?.formatted?.DateFilterTypeId)
            })
            .catch((Err) => {
                console.error(Err);
            })
    }

    useEffect(() => {
        if (id !== null && id !== undefined) {
            getFilterData()
            // setReportId(id)
        }
    }, [id])


    const customRanges: StaticRange[] = [
        {
            label: 'Last 7 Days',
            isSelected: () => false,
            range: () => ({
                startDate: subDays(new Date(), 7),
                endDate: new Date(),
            }),
        },
        {
            label: 'Last 14 Days',
            isSelected: () => false,
            range: () => ({
                startDate: subDays(new Date(), 14),
                endDate: new Date(),
            }),
        },
        {
            label: 'Last Month',
            isSelected: () => false,
            range: () => ({
                startDate: startOfMonth(subMonths(new Date(), 1)),
                endDate: endOfMonth(subMonths(new Date(), 1)),
            }),
        },
        {
            label: 'Last 3 Months',
            isSelected: () => false,
            range: () => ({
                startDate: startOfMonth(subMonths(new Date(), 4)),
                endDate: endOfMonth(subMonths(new Date(), 1)),
            }),
        },
        {
            label: 'Last Year',
            isSelected: () => false,
            range: () => ({
                startDate: new Date(new Date().getFullYear() - 1, 0, 1),
                endDate: new Date(new Date().getFullYear() - 1, 11, 31),
            }),
        },
        {
            label: 'Custom Range',
            isSelected: () => false,
            range: () => ({
                startDate: range[0].startDate,
                endDate: range[0].endDate,
            }),
        },
    ];

    const radioOnChangeHandler = (e) => {
        setSelectedOption(e.target.value)
        setSelectedIds([])
        setSelectedValues([])
        setRange([{
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        }])
    }

    const radioOptions = [
        {
            label: "Organization",
            value: FilterEntityEnum.Organization,
            checked: selectedOption == FilterEntityEnum.Organization,
            onChange: radioOnChangeHandler,
            name: "properties"
        },
        {
            label: "Properties",
            value: FilterEntityEnum.Property,
            checked: selectedOption == FilterEntityEnum.Property,
            onChange: radioOnChangeHandler,
            name: "properties"
        },
        {
            label: "Units",
            value: FilterEntityEnum.Unit,
            checked: selectedOption == FilterEntityEnum.Unit,
            onChange: radioOnChangeHandler,
            name: "properties"
        }
    ]

    const getData = (option: number) => {
        if (option == FilterEntityEnum.Property) {
            apiHelper(PropertyService.getApiPropertyOrganizationlookup, { showNotification: false }, organizationId)
                .then((response: any) => {
                    setMultiSelectOptions(response?.data?.success);
                })
                .catch((Err) => {
                    console.error(Err);
                });

        } else if (option == FilterEntityEnum.Unit) {
            setMultiSelectOptions([])
            apiHelper(UnitService.getApiUnitOrganizationlookup, { showNotification: false }, organizationId)
                .then((response: any) => {
                    setMultiSelectOptions(response?.data?.success);
                })
                .catch((Err) => {
                    console.error(Err);
                });
        } else {
            setMultiSelectOptions([])
        }
    }

    useEffect(() => {
        getData(selectedOption);
    }, [selectedOption])

    useEffect(() => {
        // Auto-recover missing entity IDs caused by legacy state bugs
        if (multiSelectOptions?.length > 0 && selectedValues?.length > 0 && selectedIds?.length === 0) {
            const recoveredIds = [];
            selectedValues.forEach(val => {
                const opt = multiSelectOptions.find(o => String(o.description) === String(val));
                if (opt && opt.id !== undefined && opt.id !== null) {
                    recoveredIds.push(opt.id);
                }
            });
            if (recoveredIds.length > 0) {
                setSelectedIds(recoveredIds);
            }
        }
    }, [multiSelectOptions, selectedValues, selectedIds]);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (selectedOption == FilterEntityEnum.Organization) {
            const isDurationSelected = relativeDateString !== "";
            setFormValidated({ ...formValidated, isSelectDuration: !isDurationSelected });
            if (isDurationSelected) {
                onViewReport({
                    selectedOption,
                    selectedValues,
                    selectedIds,
                    range,
                    relativeDateString,
                });
            }
        } else {
            const isPropertiesSelected = selectedValues.length > 0;
            const isDurationSelected = relativeDateString !== "";

            setFormValidated({
                ...formValidated,
                isSelectedProperties: !isPropertiesSelected,
                isSelectDuration: !isDurationSelected,
            });

            if (isPropertiesSelected && isDurationSelected) {
                // send values to parent (Reports)
                onViewReport({
                    selectedOption,
                    selectedValues,
                    selectedIds,
                    range,
                    relativeDateString,
                });
            }
        }
    };


    const onChangeHandler = (value) => {
        setRange(value);
        setFormValidated({
            ...formValidated,
            isSelectDuration: false,
        });
    }

    const handleCheckboxChange = (value, id) => {
        setSelectedValues((prevSelected) =>
            prevSelected?.includes(value)
                ? prevSelected?.filter((item) => item !== value)
                : [...prevSelected, value]
        );

        setSelectedIds((prevIds) =>
            prevIds?.some((item) => String(item) === String(id))
                ? prevIds?.filter((item) => String(item) !== String(id))
                : [...prevIds, id]
        );
        setFormValidated({
            ...formValidated,
            isSelectedProperties: false,
        });
    };

    return (
        <div className='filterFormContainer'>
            <form className='reportFilterForm'>
                <p className={TextCss.black.sub_heading_600_14}>Generate report for<span className='red p-1'>*</span></p>

                <div className='radio-group-container py-2'>
                    {radioOptions.map((option, index) => (
                        <RadioButton
                            key={index}
                            label={option.label}
                            value={option.value}
                            checked={option.checked}
                            onChange={option.onChange}
                            name={option.name}
                        />
                    ))}
                </div>

                {Number(selectedOption) !== FilterEntityEnum.Organization && (
                    <div className='ReportfilterInput'>
                        <p className={TextCss.black.sub_heading_600_14}>
                            {Number(selectedOption) == FilterEntityEnum.Property ? 'Properties*'
                                : Number(selectedOption) == FilterEntityEnum.Unit ? 'Units*' : null}
                        </p>


                        <MultiselectDropdown
                            options={multiSelectOptions}
                            selectedOption={selectedOption}
                            selectedIds={selectedIds}
                            placeholder={Number(selectedOption) === FilterEntityEnum.Unit ? "Select Units" : "Select Properties"}
                            onChange={handleCheckboxChange}
                            width='100%'

                        />
                        {Number(selectedOption) === FilterEntityEnum.Property && formValidated.isSelectedProperties && (
                            <div className="invalid-feedback d-block">Please select at least one property</div>
                        )}
                        {Number(selectedOption) === FilterEntityEnum.Unit && formValidated.isSelectedProperties && (
                            <div className="invalid-feedback d-block">Please select at least one unit</div>
                        )}

                        <div className='d-flex flex-wrap gap-2 py-2' style={{ width: "100%" }}>
                            {selectedValues && selectedValues.map((value, i) => (
                                <p key={i} className='selectedValueLabel normal_text d-flex align-items-center gap-2'>
                                    <span>{value}</span>
                                    <span className="clickable" style={{ fontWeight: "bold" }} onClick={() => handleCheckboxChange(value, selectedIds[i])}>×</span>
                                </p>
                            ))}
                        </div>
                    </div>
                )}
                <div className='ReportfilterInput'>
                    <p className={TextCss.black.sub_heading_600_14}>Duration <span className='red'>*</span></p>
                    <RangeDatePicker
                        range={range}
                        customRanges={customRanges}
                        onChangeHandler={onChangeHandler}
                        relativeDateString={relativeDateString}
                        setRelativeDateString={setRelativeDateString}
                    />
                    {formValidated.isSelectDuration && (
                        <div className="invalid-feedback d-block">Please select any date range</div>
                    )}

                </div>
            </form>

            <div className='filterFormButton'>
                <AddTraspButton
                    type="button"
                    bname={"Cancel"}
                    onClick={onHide}
                    width="fit-content"
                />
                <AddButtonWithArrow
                    buttonname="View Reports"
                    onClick={handleSubmit}
                />
            </div>
        </div>
    )
}

export default FiltersForm